import React, { useEffect } from "react";
import {connect} from 'react-redux';
import {getLabCategoryData} from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";

const Lab_Category = (props) => {
  useEffect(()=>{
    props.getLabCategoryData()
  },[])
  const columns = [ 
    {title: "Name",field:"name"},
    {title:'Description',field:'description'},
    {title:'Created By',field:'created_by'},

  ]

  return (
    <div className="customContainer">
    <CustomHeading title="Lab Category"/>
    <CustomTableWithAll data={props?.labCategory?.data} buttonRequired={true} buttonLabel="ADD" columns={columns} api="/api/lab-category/" identify="LabCategory" title="Lab Category"/>
  </div>
  );
};

const mapActionWithProps = {
  getLabCategoryData
}

const mapStateWithProps = (state)=>(
  {
    labCategory:state.data.labCategory
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (Lab_Category);
